module.exports = __webpack_public_path__ + "img/contract-1@2x.79261142.png";